import React,{useState, useEffect} from 'react';
import './Learning.css'; 
import { Link, useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom"; 
import p from './icon/Pyate_logo.png';  
import l from './images/learn.png';   
import courses  from './Courses'; 
import Header from './Header';                        
function Learning(){
    const location = useLocation();
      const isActive = (path) => location.pathname === path;
      const [items, setItems] = useState(courses);


      useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await fetch('https://pyate-backend-production-db97.up.railway.app/learning/courses_api');
                const data = await response.json();
                console.log("Fetched Courses:", data); // ✅ Log courses
                setItems(data);  
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        };
        fetchCourses();
    }, []);    

      const [search,setSearch] = useState('');
      console.log(search)
      
       // active class state
       const [active, setActive]=useState('');
      
       // category state
       const [category, setCategory]=useState('');
      
       // handle change ... it will set category and active states
       const handleChange=(individualSpan)=>{
           setActive(individualSpan.id);
           setCategory(individualSpan.text);
           filterFunction(individualSpan.text);
       }
      
       // filtered products state
       const [filteredProducts, setFilteredProducts]=useState([]);
      
       // filter function
       const filterFunction = (text)=>{
           if(courses.length>1){
               const filter=courses.filter((product)=>product.category===text);
               setFilteredProducts(filter);
           }
           else{
               console.log('no products to filter')
           } 
       }
      
       // return to all products
       const returntoAllProducts=()=>{
           setActive('');
           setCategory('');
           setFilteredProducts([]);
       }
       const [spans]=useState([
           {id: 'Introduction to Engineering', text: 'Engineering'},
           {id: 'Advanced BCA Programming', text: 'BCA'},           
       ])
       
    return (
      <>
      <Header/>
        <div className='Learning-pyate-app-l'>
        <nav className='learn-nav-p'>
                <div className="nav-links-learn">
                <NavLink to="/Learning" className={`nav-item-learn ${isActive("/Learning") ? "active" : ""}`}>
                    Courses
                </NavLink>
                <NavLink to="/LearnPro" className={`nav-item-learn ${isActive("/LearnPro") ? "active" : ""}`}>
                    Learning Programs
                </NavLink>
                <NavLink to="/LearnPath" className={`nav-item-learn ${isActive("/LearnPath") ? "active" : ""}`}>
                    Learning Path
                </NavLink>
                    <NavLink to="/Apply" className={`nav-item-learn ${isActive("/Apply") ? "active" : ""}`}>
                       Apply
                    </NavLink>
    
                </div>
                <div className="search-bar-header-learn">
                    <input 
                        type="search" 
                        id="search-header-learn" 
                        placeholder="Search Courses Here" 
                        style={{fontSize:"14px"}}
                        onChange={(e) => setSearch(e.target.value)}
                        aria-label="Search"
                    />
                    <button type="submit" className="search-button-learn">Search</button>
            </div>
        </nav>
             
            <div className='learn-comp-div-out'>
            <div className='container-fluid filter-products-main-box-learn'>
                <div className='filter-box-learn'>
                    <h3>Filter by category</h3>
                    {spans.map((individualSpan,index)=>(
                        <span key={index} id={individualSpan.id}
                        onClick={()=>handleChange(individualSpan)}
                        className={individualSpan.id===active ? active:'deactive'}>{individualSpan.text}</span>
                    ))}
                </div>
                
            </div>      
         <span className='card-learn-section'><section className='card-learn-comp'>
         <div className="filter-rec-btn-s-l">
  <button onClick={() => { setCategory(""); }}>All</button>
  <button onClick={() => { setCategory("Engineering"); }}>Engineering</button>
  <button onClick={() => { setCategory("BCA"); }}>BCA</button>
</div>
      
        <div className="shop_js-learn">
  {items
    .filter((card) => {
      // Apply both category and search filters
      const categoryMatch =
        category === "" || card.category.toLowerCase() === category.toLowerCase();
      const searchMatch =
        search.toLowerCase() === "" ||
        card.title.toLowerCase().includes(search.toLowerCase()) ||
        card.category.toLowerCase().includes(search.toLowerCase());
      return categoryMatch && searchMatch;
    })
    .map((card) => (
      <div className="shop_card-learn" key={card.id}>
        <img src={card.image} alt="Avatar" className="card-image-learn" />
        <div className="shop_container-learn" style={{ textAlign: "justify" }}>
          <a
            href="/Learn"
            style={{
              textDecoration: "none",
              fontSize: "11pt",
              color: "black",
            }}
          >
            {card.title}
          </a>
          <p className="card-text-learn">
            <i>{card.author}</i>
            <p>
             {card.type}
            </p>            
            <button
  className="cart-btn-entroll"
  onClick={async () => {
    try {
      const response = await fetch('https://pyate-backend-production-db97.up.railway.app/learning/enroll_api', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ course_id: card.id }),
        credentials: "include", // Ensures session cookies are sent
      });
      const data = await response.json();
      alert(response.ok ? data.message : data.error);
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
  }}
>
  Enroll Now
</button>
          </p>
        </div>
      </div>
    ))}
</div>
        </section></span></div>
        </div>
        </>
    );
}

export default Learning;